import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "49",
  fill: "none",
  viewBox: "0 0 48 49"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#EDF1F4",
      d: "M14.25 24.63h19.5v12.788h-19.5z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#AD293A",
      d: "M41.25 28.38c-1.772 1.66-4.734 5.232-6.75 8.25-3 4.5-10.5 4.5-10.5 4.5s-7.5 0-10.5-4.5c-2.016-3.018-4.978-6.59-6.75-8.25h6.75c3.337 1.192 9.966 4.529 10.5 8.25.534-3.721 7.163-7.059 10.5-8.25z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#9F2638",
      d: "M45.75 26.13s-6 6.75-15.75 1.5c0 0-2.25 1.5-6 1.5s-6-1.5-6-1.5c-9.75 5.25-15.75-1.5-15.75-1.5 1.5 0 14.25-8.25 16.5-8.25S24 21.63 24 21.63s3-3.75 5.25-3.75 15 8.25 16.5 8.25"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#AD293A",
      d: "M18 27.64c-.403.216-.806.422-1.2.6-.338-.234-2.55-1.874-2.55-4.35 0-.412.338-.75.75-.75s.75.338.75.75c0 1.81 1.894 3.113 1.922 3.122a.75.75 0 0 1 .328.629m15.748-3.723c0 2.41-2.1 4.031-2.512 4.331a17 17 0 0 1-1.228-.61.75.75 0 0 1 .328-.59c.028-.018 1.922-1.322 1.922-3.131a.744.744 0 1 1 1.49 0m3.32-19.786c.125-.29.282-.591.602-.72.542-.223 1.366.158 1.775.682.416.524.518 1.132.575 1.704.102.98.117 1.959.042 2.905.85-.92 1.818-1.756 2.87-2.5.509-.357 1.135-.71 1.88-.547 1.121.242 1.756 1.464 1.828 2.417.2 2.604-1.77 4.523-3.742 6.108-1.527 1.228-3.186 2.435-5.343 2.853-.16.03-.343.057-.506-.037-.193-.106-.258-.314-.31-.49-1.09-4.303-1.731-8.752.315-12.385z"
    }, null, -1)
  ])))
}
export default { render: render }